//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  table: {
    minWidth: 750,
  },
  rowCell: {
    fontSize: 15,
    fontFamily: "segoe-ui",
    padding: "5px",
    border: "1px solid grey",
  },
  tableContainer: {},
  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: "segoe-ui !important",
    padding: 5,
    border: "1px solid",
  },

  contentGrid: {
    textAlign: "center",
  },
  content2: {
    fontSize: 18,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 50,
  },
  pagination: {
    padding: 0,
    marginTop: 30,
    float: "right",
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    "&:hover":{
      backgroundColor: "#0a72ba",
    }
  },
  exportBtn1: {
    color: "#fff",
    width: "80px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    marginLeft:"80%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  CSVlink: {
    display: "none",
  },
  contentGrid: {
    textAlign: "center",
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0a72ba",
    }
  },
  checkIcon: {
    fontSize: 80,
    color: "green",
    verticalAlign: "middle",
  },
  content1: {
    fontSize: 25,
    fontWeight: "bold",
    padding: 30,
    textAlign: "center",
  },
  content2: {
    fontSize: 18,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 20,
  },

}));
